import { snakeCases } from "./caseStyle";

// keyValueObjects オブジェクトのネスト構造を解除して1階層にして、key名でネストを表現する
// (例: key1: { key2: x }} => { key: key1[key2], value: x )
const flattenKeyName = (params: any) => {
  const keyValues = [];
  for (const [key, v] of Object.entries(params)) {
    const value = v as any;
    if (Array.isArray(value)) {
      // 配列
      value.forEach((v) => {
        keyValues.push({ key: `${key}[]`, value: v });
      });
    } else if (value.constructor.name === "File") {
      // ファイル
      keyValues.push({ key, value });
    } else if (typeof value === "object") {
      // ネスト
      const rootKey = key;
      const childKeyValues = flattenKeyName(value);
      childKeyValues.forEach((childKeyValue) => {
        keyValues.push({ key: `${rootKey}[${childKeyValue.key}]`, value: childKeyValue.value });
      });
    } else {
      // 通常
      keyValues.push({ key, value });
    }
  }
  return keyValues;
};

// formData axiosが送信するためのパラメータを生成する (POST/PUT/PATCH)
export const parseFormData = (params: any) => {
  // paramsがFormDataの場合は、そのまま返す
  if (params instanceof FormData) {
    return params;
  }

  // refが来た場合は、解除する
  if (
    params &&
    params.constructor &&
    params.constructor.name &&
    params.constructor.name === "RefImpl"
  ) {
    params = params.value;
  }
  const snakeCaseParams = snakeCases(params);
  const keyValues = flattenKeyName(snakeCaseParams);
  if (keyValues.length === 0) {
    return {};
  }
  const formData = new FormData();
  keyValues.forEach((keyValue) => {
    formData.append(keyValue.key, keyValue.value as string);
  });
  return formData;
};
